var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgSlack = function SvgSlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#slack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M4.073 10.715a1.68 1.68 0 1 1-3.36 0c0-.93.75-1.682 1.68-1.682h1.68v1.682Zm.84 0a1.68 1.68 0 1 1 3.36 0v4.204a1.68 1.68 0 1 1-3.36 0v-4.204Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M6.593 3.963a1.68 1.68 0 0 1-1.68-1.681 1.68 1.68 0 1 1 3.36 0v1.681h-1.68Zm0 .854c.93 0 1.68.751 1.68 1.681a1.68 1.68 0 0 1-1.68 1.682H2.38A1.68 1.68 0 0 1 .7 6.498c0-.93.751-1.681 1.68-1.681h4.213Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M13.327 6.498a1.68 1.68 0 1 1 3.36 0 1.68 1.68 0 0 1-1.68 1.682h-1.68V6.498Zm-.84 0a1.68 1.68 0 1 1-3.36 0V2.282a1.68 1.68 0 1 1 3.36 0v4.216Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M10.807 13.237c.929 0 1.68.752 1.68 1.681a1.68 1.68 0 1 1-3.36 0v-1.681h1.68Zm0-.84a1.68 1.68 0 0 1-1.68-1.682c0-.93.75-1.682 1.68-1.682h4.213c.929 0 1.68.752 1.68 1.682a1.68 1.68 0 0 1-1.68 1.681h-4.213Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "slack_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v17H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSlack);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;